import { Button, Group, Stack, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import CriterioListItem from "./CriterioListItem";

type CriteriosListProperties = {
  criterios: TCriterioRubrica[];
  onAdd: () => void;
  onEdit: (criterio: TCriterioRubrica, index: number) => void;
  onRemove: (index: number) => void;
  error?: string;
};

/**
 * Renderiza a lista de critérios com controles
 * @param props - Propriedades do componente
 * @param props.criterios
 * @param props.onAdd
 * @param props.onEdit
 * @param props.onRemove
 * @param props.error
 */
function CriteriosList({ criterios, onAdd, onEdit, onRemove, error }: CriteriosListProperties): JSX.Element {
  return (
    <>
      <Group justify="space-between" align="center">
        <Text fw={600}>Critérios</Text>
        <Button size="xs" variant="outline" leftSection={<IconPlus size={14} />} onClick={onAdd}>
          Adicionar criterio
        </Button>
      </Group>

      {error && (
        <Text size="sm" c="red">
          {error}
        </Text>
      )}

      {criterios.length === 0 ? (
        <Text size="sm" c="dimmed">
          Nenhum critério cadastrado.
        </Text>
      ) : (
        <Stack gap="xs">
          {criterios.map((criterio, index) => (
            <CriterioListItem
              key={`${criterio.id}-${index}`}
              criterio={criterio}
              index={index}
              onEdit={onEdit}
              onRemove={onRemove}
            />
          ))}
        </Stack>
      )}
    </>
  );
}

export default CriteriosList;
